module.exports = __webpack_public_path__ + "static/media/profilepic2.a2102c65.png";